import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import {Link} from 'react-router-dom';
import Icon from 'react-icons-kit';
import {androidDelete} from 'react-icons-kit/ionicons/androidDelete';
import {edit} from 'react-icons-kit/ionicons/edit';

import './style.css';

class EditSecSubQuestion extends Component {
  constructor(props){
    super(props)
   

    this.state={
        subQuesID : '',
        secSubQuesID : '',
        sec_sub_ques_id : '',
        catID : "",
        quesID : "",
        order_no :"",
        questions:"",
        selectionType : "",
        showaddSecondSubQuestionbutton : false,
        validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.updatesubQuestion = this.updatesubQuestion.bind(this);
  }

  componentWillMount(){
   
    if(this.props.demoGraphicsEditSecSubQuestionSuccess && this.props.demoGraphicsEditSecSubQuestionData){
      this.setState({
      sec_sub_ques_id : this.props.demoGraphicsEditSecSubQuestionData[0]._id,
      secSubQuesID : this.props.demoGraphicsEditSecSubQuestionData[0].sec_sub_ques_id,
      subQuesID :this.props.demoGraphicsEditSecSubQuestionData[0].sub_ques_id,
      catID : this.props.demoGraphicsEditSecSubQuestionData[0].cat_id,
      quesID : this.props.demoGraphicsEditSecSubQuestionData[0].ques_id,
      order_no : this.props.demoGraphicsEditSecSubQuestionData[0].orderSecondSubQues+"",
      questions : this.props.demoGraphicsEditSecSubQuestionData[0].questions,
      selectionType : this.props.demoGraphicsEditSecSubQuestionData[0].selectionType,
      });
   }
  }

  componentWillReceiveProps(nextProps){
    
   if(nextProps.secSubQuestionUpdateSuccess && nextProps.secSubQuestionUpdateSuccessMessage){
    alert(nextProps.secSubQuestionUpdateSuccessMessage);
    this.props.emptyDemoSecSubQuestionResponse();

   }else if(nextProps.secSubQuestionUpdateFailMessage){
    alert(nextProps.secSubQuestionUpdateFailMessage);
    this.props.emptyDemoSecSubQuestionResponse();
   }
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
    
    let valid = true;
    let error = {};

    if (this.state.questions === "") {
        error.questions = "Can't leave empty";
        valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }
   
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

    updatesubQuestion(){
    let secSubQuesData = {};
      if (this.handleValidation()) {
        secSubQuesData._id =  this.state.sec_sub_ques_id;
        secSubQuesData.cat_id = this.state.catID;
        secSubQuesData.ques_id = this.state.quesID; //subQuesID
        secSubQuesData.subQuesID = this.state.subQuesID
        secSubQuesData.secSubQuesID = this.state.secSubQuesID;
        secSubQuesData.orderSecondSubQues = this.state.order_no;   
        secSubQuesData.questions = this.state.questions;
        secSubQuesData.selectionType = this.state.selectionType;  
        this.props.updateSecSubQuestion(secSubQuesData);  
    }
  }

  categoryList(){
    this.props.categoryList();
  }

  gotoBack(){
    window.history.back();
  }

  softDeleteOption(data){
    this.props.softDeleteSecSubOption(data);
  }

  gotoSecondSubquestionView(){
    let catID = this.state.catID;
    let quesID = this.state.quesID;
    let subQuesID = this.state.subQuesID;
    this.props.gotoSecondSubquestionView( catID, quesID, subQuesID);
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      let OptionsList = "";
    if(this.props.demoGraphicsCatSecSubQuesOptionsListSuccess && this.props.demoGraphicsCatSecSubQuesOptionsListData && this.props.demoGraphicsCatSecSubQuesOptionsListData.length > 0){
        let options = this.props.demoGraphicsCatSecSubQuesOptionsListData;
        OptionsList = Object.keys(options).map((item, index) => {
        let optionItem = options[item];


        return <tr key={index} >
            <td style ={{ textAlign : "center" }}>{index+1}</td>
            <td >{ this.state.questions}</td>
            <td>{optionItem.options}</td>
            <td style ={{ textAlign : "center" }}>{optionItem.order_no}</td>
            <td className = "cat_action">
            <Link to={{
              pathname: '/demoEditSecSubOption/&ssop:'+ optionItem._id,
              }}>
              < Icon icon={edit} size={30} style={{ color: '#336699' }}/>
            </Link>
            <button onClick = {this.softDeleteOption.bind(this, optionItem)} className = "removebutton">< Icon icon={androidDelete} size={30} style={{ color: '#EF233C' }}/></button>            
            </td>
          </tr>
          });
    }else{
      OptionsList = "No data"
    }

    let showaddSecondSubQuestionBtn = "";
    if(this.state.showaddSecondSubQuestionbutton){
      showaddSecondSubQuestionBtn = <button className = "demoRightbtn"  onClick={this.gotoSecondSubquestionView.bind(this)}>Subquestions</button>
    }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1>Second Sub Question</h1></div>
            <div className = "setbackbutton">
            <br/>

            
            <button className = "editstudybackbtn" onClick={this.gotoBack}  >Back</button>
            {showaddSecondSubQuestionBtn}
            <br/>
            <div className = "studypage">
            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >
            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>

            <div>
            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.updatesubQuestion}  >Update</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
            </div>
          </div>
        
        {/* //............................. */}

        <hr/>

          <div className = "catQuesListHeading"><h3>Second Sub Question's Option List</h3></div>

          <Link to={{
                pathname: '/demoAddSecSubOption/&q:'+ this.state.quesID +'/&sq:'+ this.state.subQuesID+'/&ssq:'+ this.state.secSubQuesID,
              
                }}><button  className = "createCouponbtn" >
          Add Option</button></Link>

          <div className = "autoscroll">
          <table className = "demoategoryTable">
            <thead>
              <tr >
                <th>Sr.No.</th>
                <th>Question</th>
                <th>Option</th>
                <th>Order No.</th>
                <th>Action</th> 
              </tr>
            </thead>
              <tbody> 
                {OptionsList}
              </tbody>
          </table>
          </div>

        
        </div>
      </div>
    );
  }
}
export default EditSecSubQuestion;


// WEBPACK FOOTER //
// ./src/components/demographics/editSecSubQuestion.js